const SUPPORTED_LANGUAGES: any = [
  { key: "en", value: "English" },
  { key: "en-gb", value: "English UK" },
  { key: "ar", value: "Arabic" },
  { key: "bg", value: "Bulgarian" },
  { key: "zh", value: "Chinese (Simplified)" },
  { key: "zh-TW", value: "Chinese (Traditional)" },
  { key: "hr", value: "Croatian" },
  { key: "cs", value: "Czech" },
  { key: "da", value: "Danish" },
  { key: "nl", value: "Dutch" }, //Dutch
  { key: "et", value: "Estonian" },
  { key: "fi", value: "Finnish" },
  { key: "fr", value: "French" }, // French
  { key: "fr-CA", value: "French(Canada)" }, // French (Canada)
  { key: "de", value: "German" }, // German
  { key: "el", value: "Greek" },
  { key: "he", value: "Hebrew" },
  { key: "hu", value: "Hungarian" }, //Hungarian
  { key: "it", value: "Italian" }, //Italian
  { key: "lv", value: "Latvian" },
    { key: "ja", value: "Japanese" },
  { key: "ko", value: "Korean" },
  { key: "lt", value: "Lithuanian" },
  { key: "no", value: "Norwegian" },
  { key: "pl", value: "Polish" },
  { key: "pt", value: "Portuguese(Brazil)" }, //Portuguese (Brazil)
  { key: "pt-PT", value: "Portuguese(Portugal)" }, //Portuguese (Portugal)
  { key: "ro", value: "Romanian" },
  { key: "ru", value: "Russian" },
  { key: "sk", value: "Slovak" },
  { key: "sl", value: "Slovenian" },
  { key: "es", value: "Spanish" }, //Spanish
  { key: "es-MX", value: "Spanish (Mexico)" },
  { key: "sv", value: "Swedish" },
  { key: "th", value: "Thailand" },
  { key: "tr", value: "Turkish" },
  { key: "vi", value: "Vietnamese" }

];

export default SUPPORTED_LANGUAGES

